define("calendar/components/calendar/settings/bttp/error", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <p class="u--text--bold" data-test-id="bttp-error">
    {{svg-jar "warning" class="o--icon o--icon--warning u--m__r__xs"}}
    {{#if @isLegacyBttp}}
      {{t "bttp.errors.not_enough_posts"}}
    {{else}}
      {{t "bttp.errors.unable_to_generate"}}
    {{/if}}
  </p>
  <p>
    {{html-safe @bttpReport.reportErrorText}}
  </p>
  
  {{#if @isLegacyBttp}}
    <p class="u--m__b__0">
      {{html-safe (t "bttp.num_of_posts" num=@bttpReport.numOfPosts nickname=@singleSocialProfile.displayNickname)}}
    </p>
    <div class="u--m__b__xs u--text--sm u--text--light">
      <span>{{@bttpInclusionDateText}}</span>
      <span class="u--float--right">
        {{t "bttp.required_posts" num=@bttpReport.requiredBttpPostData}}
      </span>
    </div>
    <div class="o--progress">
      <div class="o--progress__line" style={{@postPercentageCSS}}></div>
    </div>
  
    <p class="u--m__b" data-test-id="bttp-followers-user-info">
      {{html-safe
        (t
          "bttp.more_followers_required_details"
          nickname=@nickname
          followers=@numberOfFollowers
          required_followers=@requiredFollowers
          profile_type=@profileType
        )
      }}
    </p>
  {{/if}}
  
  {{#unless @isOnLegacyPlan}}
    <Calendar::Settings::Bttp::InfoCard />
  {{/unless}}
  */
  {
    "id": "Fl3yvL5v",
    "block": "[[[10,2],[14,0,\"u--text--bold\"],[14,\"data-test-id\",\"bttp-error\"],[12],[1,\"\\n  \"],[1,[28,[35,0],[\"warning\"],[[\"class\"],[\"o--icon o--icon--warning u--m__r__xs\"]]]],[1,\"\\n\"],[41,[30,1],[[[1,\"    \"],[1,[28,[35,2],[\"bttp.errors.not_enough_posts\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,2],[\"bttp.errors.unable_to_generate\"],null]],[1,\"\\n\"]],[]]],[13],[1,\"\\n\"],[10,2],[12],[1,\"\\n  \"],[1,[28,[35,3],[[30,2,[\"reportErrorText\"]]],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,1],[[[1,\"  \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[[28,[37,2],[\"bttp.num_of_posts\"],[[\"num\",\"nickname\"],[[30,2,[\"numOfPosts\"]],[30,3,[\"displayNickname\"]]]]]],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--m__b__xs u--text--sm u--text--light\"],[12],[1,\"\\n    \"],[10,1],[12],[1,[30,4]],[13],[1,\"\\n    \"],[10,1],[14,0,\"u--float--right\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"bttp.required_posts\"],[[\"num\"],[[30,2,[\"requiredBttpPostData\"]]]]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"o--progress\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"o--progress__line\"],[15,5,[30,5]],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,2],[14,0,\"u--m__b\"],[14,\"data-test-id\",\"bttp-followers-user-info\"],[12],[1,\"\\n    \"],[1,[28,[35,3],[[28,[37,2],[\"bttp.more_followers_required_details\"],[[\"nickname\",\"followers\",\"required_followers\",\"profile_type\"],[[30,6],[30,7],[30,8],[30,9]]]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[51,[30,10]],[[[1,\"  \"],[8,[39,5],null,null,null],[1,\"\\n\"]],[]],null]],[\"@isLegacyBttp\",\"@bttpReport\",\"@singleSocialProfile\",\"@bttpInclusionDateText\",\"@postPercentageCSS\",\"@nickname\",\"@numberOfFollowers\",\"@requiredFollowers\",\"@profileType\",\"@isOnLegacyPlan\"],false,[\"svg-jar\",\"if\",\"t\",\"html-safe\",\"unless\",\"calendar/settings/bttp/info-card\"]]",
    "moduleName": "calendar/components/calendar/settings/bttp/error.hbs",
    "isStrictMode": false
  });

  // eslint-disable-next-line ember/no-empty-glimmer-component-classes
  class ErrorComponent extends _component2.default {}
  _exports.default = ErrorComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ErrorComponent);
});